<template>
    <base-modal
        size="small"
        :value="showPopup"
        :close-on-click-overlay="false"
        @close="hideAuthorization"
    >
        <crm-authorization-form
            v-if="showPopup"
            :data-path="dataPath"
            :type="direction"
            :product="product"
            :locked="true"
            :connection-link-data="connectionLinkData"
        />
    </base-modal>
</template>

<script>
import qs from 'qs';
import { get } from 'lodash-es';
import { mapActions, mapMutations } from 'vuex';
import crmAuthorizationForm from '@/components/crm-authorization-form/crm-authorization-form';
import {
    HIDE_STEP_LOADING,
    PLATFORM_DATA_SET,
    SHOW_AUTHORIZATION,
    SHOW_PAGE_MESSAGE,
    SHOW_STEP_LOADING,
    SUBMIT_STEP,
} from '@/utils/event/constants.ts';
import { emitter } from '@/utils/event/emitter.ts';
import { instance } from '@/api/api.ts';

export default {
    name:       'AuthorizationWrapper',
    components: {
        crmAuthorizationForm,
    },
    props:      {
        dataPath: {
            type:     String,
            required: true,
        },
        product:  {
            type: String,
        },
    },
    data() {
        return {
            direction:   'source',
            migrationId: undefined,
            crmId:       undefined,
            showPopup:   false,
        };
    },
    mounted() {
        emitter.on(SHOW_AUTHORIZATION, (data) => {
            this.$store.commit('manager/applyManagerData', data);

            this.direction = data.direction;
            this.migrationId = data.migrationId;
            this.crmId = data.crmId;

            this.setPlatformData({
                prefix: data.direction,
                data:   data.platformData,
            });
            emitter.emit(PLATFORM_DATA_SET);

            this.showPopup = true;
        });
        emitter.on(SHOW_STEP_LOADING, () => {
            this.showLoader();
        });
        emitter.on(HIDE_STEP_LOADING, () => {
            this.hideLoader();
        });
        emitter.on(SUBMIT_STEP, this.submitStep);
    },
    methods: {
        ...mapActions({
            showLoader: 'loader/SHOW',
            hideLoader: 'loader/HIDE',
        }),
        ...mapMutations({
            setPlatformData: 'platform/SET_PLATFORM_DATA',
        }),
        connectionLinkData() {
            return {
                id:        this.crmId,
                direction: this.direction,
                origin:    this.product,
            };
        },
        hideAuthorization() {
            this.showPopup = false;
            this.$store.commit('manager/clearManagerData');
            this.$emit('close');
        },
        submitStep({ data: send, onSuccess, onError, stringify = true }) {
            emitter.emit(SHOW_STEP_LOADING);

            const sendData = {
                ...send,
                direction:   this.direction,
                migrationId: this.migrationId,
                crmId:       this.crmId,
            };

            instance.post(
                '/manager/authorization/authorize',
                stringify ? qs.stringify(sendData) : sendData,
            ).then((data) => {
                emitter.emit(HIDE_STEP_LOADING);

                if (typeof onSuccess === 'function') {
                    onSuccess(data);
                }

                this.$emit('success', this.direction);

                this.hideAuthorization();
            }).catch(({ data, response }) => {
                emitter.emit(HIDE_STEP_LOADING);

                if (!Object.is(get(response.data.detail, 'message'), null)) {
                    emitter.emit(
                        SHOW_PAGE_MESSAGE,
                        {
                            type:    'danger',
                            content: response.data.detail.message,
                        },
                    );
                    setTimeout(() => {
                        const elem = document.getElementById('page-error');
                        if (elem) {
                            elem.scrollIntoView({ behavior: 'smooth' });
                        }
                    }, 100);
                }

                if (typeof onError === 'function') {
                    onError(data, response);
                }
            });
        },
    },
};
</script>
